//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../Features/Features.SelectFeature.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[0,"AssoToggle",1,0],[1,"BaseDim",0,"Expression",0],[1,"DriverPlane",0,"Expression",0],[1,"EyeFeature",0,"Features.SelectFeature",0],[0,"EyeType",1,0],[1,"FrontDim",0,"Expression",0],[1,"FrontPlane",0,"Expression",0],[0,"LoadingName",1,0],[0,"LowerPlane",1,0],[1,"MidPlane",0,"Expression",0],[0,"MiddlePlane",1,0],[1,"PassengerPlane",0,"Expression",0],[0,"PointV1",1,"Point",0],[0,"PointV2",1,"Point",0],[1,"SDistance",0,"Expression",0],[0,"SPlane",1,0],[0,"UpperPlane",1,0],[0,"UseStandardLoading",1,0],[0,"VisionType",1,0]],[],[]];
SPLM.Features.VehicleDesign.VisionPlaneBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.VisionPlaneBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.VisionPlaneBuilder.EnumEyeType = Object.freeze({
    "EyeFeature" : "EyeFeature", "V1Point" : "V1Point", "V2Point" : "V2Point"});

SPLM.Features.VehicleDesign.VisionPlaneBuilder.CustomVisionAngle = Object.freeze({
    "Standard" : "Standard", "Custom" : "Custom"});

export default SPLM;